import styled from 'styled-components';
import { Link } from 'react-router-dom';

import colors from 'themes/Main';

const { gray01, gray02, gray03, gray06, blue, white } = colors;

export const ProjectContainer = styled.div`
  cursor: default;
  z-index: -1;
  width: 100%;
  border-radius: 3px;
  background-color: ${white};
  box-shadow: 0px 1px 3px rgba(219, 219, 219, 0.2),
    0px 2px 2px rgba(219, 219, 219, 0.12), 0px 0px 2px rgba(219, 219, 219, 0.14);

  &:not(:last-child) {
    margin-bottom: 16px;
  }

  &:last-child {
    margin-bottom: 64px;
  }
`;

export const ProjectContent = styled.div`
  width: 100%;
  padding: 20px;
  display: flex;
  justify-content: space-around;
`;

export const ProjectItems = styled.ul`
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  margin: 0;
  padding: 0;

  > li:first-child {
    width: 20vw;
    color: ${gray01};
    font-weight: 700;
  }

  > li:not(:first-child) {
    width: 15vw;
  }

  > li:nth-child(2) {
    text-align: center;
  }
`;

export const Item = styled.li`
  list-style: none;
  color: ${gray02};
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;

  span {
    display: block;
    font-size: 12px;
    font-weight: 600;
    color: ${gray03};
    margin-bottom: 4px;
  }
`;

export const ProjectMore = styled.div`
  cursor: pointer;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover > div {
    display: block;
  }
`;

export const MoreActions = styled.div`
  z-index: 20;
  display: none;
  position: absolute;
  top: 8px;
  left: -40px;
  min-width: 180px;
  border-radius: 5px;
  box-shadow: 0px 4px 5px rgba(215, 220, 230, 0.2),
    0px 3px 14px rgba(215, 220, 230, 0.12),
    0px 8px 10px rgba(215, 220, 230, 0.14);
  background-color: ${white};
  transition: all 0.1s ease-out;
  margin-bottom: 64px;
`;

export const MoreActionsHeader = styled.p`
  cursor: default;
  font-weight: 700;
  font-size: 14px;
  text-transform: uppercase;
  color: ${gray03};
  padding: 16px 16px 0;
`;

export const MoreActionsItem = styled(Link)`
  cursor: pointer;
  display: inline-block;
  width: 100%;
  padding: 8px 16px;
  border-top: 1px solid ${gray06};
  border-bottom: 1px solid ${gray06};
  color: ${gray01};
  font-size: 16px;
  transition: all 0.3s ease-in;
  text-decoration: none;

  &:hover {
    color: ${white};
    background-color: ${blue};
  }

  &:last-child {
    border-bottom: 0;
    margin-bottom: 16px;
  }
`;
